import { render, staticRenderFns } from "./asset-edit.vue?vue&type=template&id=6262edd6&scoped=true&"
import script from "./asset-edit.vue?vue&type=script&lang=js&"
export * from "./asset-edit.vue?vue&type=script&lang=js&"
import style0 from "./asset-edit.vue?vue&type=style&index=0&id=6262edd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6262edd6",
  null
  
)

export default component.exports